// External deps
import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { Button, Input, ModalGeneric } from 'ypf-pas-general-ui-components';
import { useHistory } from 'react-router-dom';

// Internal deps
import useToast from '../../../../../hooks/useToast';
import LoaderContext from '../../../../../context/LoaderProvider';
import { generateRequestTemplate } from '../../../../../adapters/requestTemplate/requestTemplateAdapter';
import { useFilesContext } from '../../../../../context/FilesProvider';

// isDraw means info was loaded from an SDS draft
// and when isDraw is true, we should receive its id

// isDraft refers to whether we are editing an existing template
// id refers to a template id, received when editing a template
const GenerateRequestTemplateButtons = ({
  isDraft,
  isDraw,
  id,
  previusPath,
  visualizePublicTemplate,
  requestTemplateIsOwn
}) => {
  const [showModalEditName, setShowModalEditName] = useState(false);
  const { postFilesClientServiceTemplate, dataAdjuntos, copyExistingFiles } = useFilesContext();
  const { values, setFieldValue } = useFormikContext();
  const { setLoader } = useContext(LoaderContext);
  const { setNewToast } = useToast();
  const history = useHistory();

  const postFiles = async (accordions, solicitudes) => {
    solicitudes.map(async (solicitud, index) => {
      await postFilesClientServiceTemplate(accordions[index], solicitud?.id);
      if (isDraw)
        await copyExistingFiles(
          accordions[index],
          // sourceId
          accordions[index]?.serviceRequestId,
          // targetId
          solicitud?.id,
          isDraw
        );
    });
  };

  const goToPreviusPath = () => {
    history.push({
      pathname: previusPath || '/manage-temp/request',
      openTemplateMOdal: previusPath === '/createMultiple'
    });
  };

  const openModalSaveTemplateAsOwn = () => {
    setShowModalEditName(true);
  };

  const generateTemplate = async () => {
    try {
      setLoader(true);
      const response = await generateRequestTemplate(values, null, false);

      if (dataAdjuntos.length) {
        await postFiles(values?.accordions, response?.solicitudes);
      }
      setNewToast({
        type: 'SUCCESS',
        message: response.mensaje
      });
      setLoader(false);
      goToPreviusPath();
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setLoader(false);
    }
  };

  const editTemplate = async () => {
    try {
      setLoader(true);
      const response = await generateRequestTemplate(values, dataAdjuntos, id);

      // If a new service was added and attachments were added to it
      if (dataAdjuntos.some((adj) => !adj.serviceRequestId)) {
        // Dismiss persisted Services
        const newAccordions = values?.accordions.filter((acc) => !acc.templeteRequestId);
        // Dismiss persisted service ids
        const newRequestId = response?.solicitudes.filter(
          (sol) => !values?.accordions.some((acc) => acc.templeteRequestId === sol.id)
        );

        await postFiles(newAccordions, newRequestId);
      }

      setNewToast({
        type: 'SUCCESS',
        message: response.mensaje
      });
      setLoader(false);
      history.push('/manage-temp/request');
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
      setLoader(false);
    }
  };

  return (
    <>
      {visualizePublicTemplate && !requestTemplateIsOwn && (
        <div className="d-flex justify-content-center mt-4 gap">
          <Button
            label="Guardar plantilla como propia"
            onClick={openModalSaveTemplateAsOwn}
            type="button"
            variant="primary"
            widthButton="220px"
          />
        </div>
      )}
      {!visualizePublicTemplate && (
        <div className="d-flex justify-content-center mt-4 gap">
          <Button label="Salir" onClick={goToPreviusPath} type="button" variant="outline-primary" />
          {isDraft ? (
            <Button
              label="Guardar cambios"
              onClick={editTemplate}
              type="button"
              variant="primary"
            />
          ) : (
            <Button
              disabled={values?.templateName === '' || values?.ubication?.ubicationType === null}
              label="Crear plantilla"
              onClick={generateTemplate}
              type="button"
              variant="primary"
            />
          )}
        </div>
      )}
      <ModalGeneric
        backdrop="static"
        infoModal
        onHide={() => {}}
        primaryAction={generateTemplate}
        primaryActionDisabled={false}
        primaryActionLabel="Guardar plantilla como propia"
        primaryActionVariant="primary"
        secondaryAction={() => {
          setShowModalEditName(false);
        }}
        secondaryActionLabel="Salir"
        show={showModalEditName}
        size="md"
        title="Guardar plantilla como propia"
        variantHeader="info"
      >
        <div className="d-flex flex-column gap-4 align-items-center justify-content-center">
          <h4>Antes de guardar la plantilla, podés cambiarle el nombre en el siguiente campo:</h4>
          <Input
            className="w-100"
            label="Nombre de la plantilla"
            onChange={(e) => setFieldValue('templateName', e.target.value)}
            placeholder="Ingrese el nombre de la plantilla"
            value={values.templateName}
          />
        </div>
      </ModalGeneric>
    </>
  );
};

export default GenerateRequestTemplateButtons;

GenerateRequestTemplateButtons.propTypes = {
  id: PropTypes.number,
  isDraft: PropTypes.bool,
  isDraw: PropTypes.bool,
  previusPath: PropTypes.string.isRequired,
  visualizePublicTemplate: PropTypes.bool,
  requestTemplateIsOwn: PropTypes.bool
};

GenerateRequestTemplateButtons.defaultProps = {
  isDraft: false,
  isDraw: false,
  id: null,
  requestTemplateIsOwn: true,
  visualizePublicTemplate: false
};
